import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon } from "react-bootstrap";
import Highlight from "react-highlight";
import { Navigation, Link } from "react-router";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import UserHandler from "js/utilities/user-handler";
import { ZOOM_ICON } from "js/config.jsx";
import SDKSidebar from "js/utilities/sdk-sidebar"

export default React.createClass({
  displayName: "matching-guide",
  scrollToGuide: null,
  scrollingEl: null,
  getInitialState: function () {
    var data = [{ name: "Matching Guide" }
    ];

    var scrollToElement = initDeepLinkData(this.props);

    return {
      data,
      navMenuParent: null,
      navMenu: null,
      android_release_version: "",
      android_release_date: "",
      ios_release_version: "",
      ios_release_date: "",
      server_java_release_version: "",
      server_java_release_date: "",
      server_c_release_version: "",
      server_c_release_date: "",
      zoom_web_release_version: "",
      zoom_web_release_date: "",
      scrollToElement: scrollToElement,
      isMobile: false
    };
  },

  componentDidMount: function () {
    mountCode(this);
    this.setState({isMobile: window.innerWidth <= 760});
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function () {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="matching-guide">Matching Guide</h2>
                </div>
                <p>The FaceTec 3D Matching Algorithms are the best in the world, operating at a FAR of 1 in 4,200,000 with less than 1% FRR.  Match Levels correspond to probabilities that the given pair of samples is the same person..  Please read below to find out more.</p>
                <hr/>
              </section>

              <section>
                <div className="row">
                  <div className={this.state.isMobile == true? "col-xs-12" : "col-xs-7"}>
                    <h3 id="matching-fundamentals" className="inside-section">Matching Fundamentals</h3>
                    <p>
                      Here are a few important points before diving into the rest of the documentation on this page:
                    </p>
                    <ul>
                      <li><p>FaceTec supports 3D to 3D Matching.  i.e. Matching a FaceTec 3D FaceMap to another FaceTec 3D FaceMap.</p></li>
                      <li><p>FaceTec supports 3D to 2D Matching - i.e. Matching a FaceTec 3D FaceMap to a Single 2D Image like a photo captured from a government-issued identity document.</p></li>
                      <li><p>FaceTec supports 2D to 2D Matching - i.e. Matching a Single 2D Image to another Single 2D Image.  This scenario is equivalent to any legacy/traditional face recognition systems.</p></li>
                      <li><p>FaceTec operates in a specific and tailored mode for 1:N Search in order to achieve sub-second response times over databases of millions of records (hardware-dependent).</p></li>
                    </ul>
                  </div>

                  <div className={this.state.isMobile == true? "col-xs-12" :"col-xs-5 splitSectionBorder"}>
                    <br/>
                    <h3 id="match-levels" className="inside-section">Match Levels</h3>
                    <p>Here are the FaceTec Match Levels and associated probabilities:</p>

                    <ul>
                      <li><p>FaceTec Match Level 10 - 1/4,200,000 FAR</p></li>
                      <li><p>FaceTec Match Level 9 - 1/2,000,000 FAR</p></li>
                      <li><p>FaceTec Match Level 8 - 1/1,000,000 FAR</p></li>
                      <li><p>FaceTec Match Level 7 - 1/500,000 FAR</p></li>
                      <li><p>FaceTec Match Level 6 - 1/100,000 FAR</p></li>
                      <li><p>FaceTec Match Level 5 - 1/10,000 FAR</p></li>
                      <li><p>FaceTec Match Level 4 - 1/1,000 FAR</p></li>
                      <li><p>FaceTec Match Level 3 - 1/500 FAR</p></li>
                      <li><p>FaceTec Match Level 2 - 1/250 FAR</p></li>
                      <li><p>FaceTec Match Level 1 - 1/100 FAR</p></li>
                      <li><p>FaceTec Match Level 0 - Non-match</p></li>
                    </ul>
                  </div>
                </div>
                <hr />
              </section>

              <section>
               <h3 id="introduction-and-background" className="inside-section">Introduction and Background</h3>
                <p>Liveness Detection and Matching are the two primary functions of FaceTec SDKs.</p>
                <p>FaceTec Liveness Detection is the only Certified (iBeta/NIST/ISO 30107) solution on the market and miles ahead of any other competing technology.  FaceTec SDKs are trusted to perform hundreds of thousands of Liveness Checks on real users and real spoofs every month.  Please refer to our White Papers for a wealth of information about our Liveness Algorithms and Certifications.</p>
                <p>FaceTec 3D Matching Algorithms are also the strongest and most advanced in the world.  FaceTec leverages 3D FaceMap Technology to achieve levels of accuracy many times better than Apple’s Face ID technology and many times better (and in some cases many orders of magnitude better!) than NIST measures in its ongoing vendor tests.  FaceTec SDKs achieve a 1/4,200,000 False Accept Rate at less than 1% False Reject Rate for its 3D Matching Algorithms under real-world conditions.</p>
                <p><a target="_blank" href="https://www.facetec.com/FaceTec_3D_Face_Matching_Whitepaper.pdf">Please see the FaceTec SDK 1/4,200,000 FAR Matching Report</a> for a wealth of information on the FaceTec 3D Matching Algorithms themselves, as well as extensive comparisons of our algorithm accuracy against other industry benchmarks.  Spoiler alert:  FaceTec 3D Face Matching blows them all out of the water.</p>
              </section>

              <hr />


              <section className="getting-started-videos">
                <h3 id="get-started-with-matching">Get Started with Matching</h3>
                <p>To get started with Matching, load any of the Sample Apps and use the Enroll and Authenticate functionality.</p>
                <hr />
              </section>


              <section>
                <h3 id="3d-and-2d-matching">3D and 2D Matching - Technical Guide</h3>
                <p>FaceTec supports matching across any combination and quantity of 3D and 2D scenarios.</p>

                <h4 id="3d-to-3d">1-to-1, 3D to 3D Matching</h4>
                <p><em>Note: "Match Level: 0" and "Match Level: 10" are the only possible responses for 3D Matching.</em></p>
                <p>Steps:</p>
                <ol>
                  <li><p>Call prepareAndUpdateFaceMap on both FaceTec 3D FaceMaps.</p></li>
                  <li><p>Call match3D_3D, passing in both FaceTec 3D FaceMaps.</p></li>
                </ol>

                <hr />

                <h4 id="3d-to-2d">1-to-1, 3D to 2D Matching</h4>
                <blockquote>
                  <p>Learn about How FaceTec Matches 3D FaceMaps to Photo ID Documents: <Link to="photo-id-match-guide">Photo ID Matching</Link>.  This is the recommended approach for Matching 3D FaceMaps to Photo ID Document.  To perform less accurate, manual comparisons, please see the steps below.</p>
                </blockquote>
                <p><em>Note: Match Level: 0 - 7 will be returned. The order of the FaceMaps passed into the function matters here, the first FaceMap should be the 3D FaceMap and the second should be the 2D FaceMap.</em></p>
                <p>Steps:</p>
                <ol>
                  <li><p>Call prepareAndUpdateFaceMap on the FaceTec 3D FaceMap.</p></li>
                  <li><p>Call createFaceMapFromImage on the 2D Single Image.</p></li>
                  <li><p>Call match3D_2D, passing in the FaceTec 3D FaceMap and the 2D Single Image FaceMap.</p></li>
                </ol>

                <hr />

                <h4 id="2d-to-2d">1-to-1, 2D to 2D Matching</h4>
                <p><em>Note: Match Level: 0 - 6 will be returned.</em></p>
                <p>Steps:</p>
                <ol>
                  <li><p>Call createFaceMapFromImage on both 2D Single Images.</p></li>
                  <li><p>Call match2D_2D, passing in both 2D Single Image FaceMaps.</p></li>
                </ol>

                <hr />

                <h4 id="1-to-n-search">1-to-N Search</h4>
                <p><Link to="1-to-n-search">Click here for more information on 1:N Search.</Link></p>
              </section>

              <hr />

              <section>
                <h3 id="3d-facemap-info">FaceTec 3D FaceMaps</h3>
                <p>The FaceTec 3D FaceMap technology is relied upon by all core functions of the FaceTec SDK platform.</p>

                <p>FaceTec 3D FaceMaps are generated from every completed User Session. Additionally, FaceTec 3D FaceMaps are:</p>

                <ul>
                  <li><p><strong>Encrypted</strong>: This is required and enforced by the FaceTec SDK APIs.</p></li>
                  <li><p><strong>Proprietary</strong>: FaceTec 3D FaceMaps cannot be used by anything other than the FaceTec Server SDK.</p></li>
                  <li><p><strong>Created via a patented process</strong>: Users performing User Sessions from any device are using FaceTec’s patented interface to create FaceTec 3D FaceMaps.</p></li>
                  <li><p><strong>Cross-platform</strong>: FaceMaps from iOS, Android, or Browser can be used interchangeably.</p></li>
                  <li><p><strong>Data-rich</strong>: FaceTec 3D FaceMaps are created by processing (in most cases) upwards of 100 frames of data from the raw camera data.</p></li>
                  <li><p><strong>Future-proof and forward-compatible</strong>: FaceTec 3D FaceMaps created today are guaranteed to be able to leverage future FaceTec Matching Algorithm improvements.</p></li>
                  <li><p><strong>Not a Honeypot Risk</strong>: Liveness Data used for Liveness Detection is deleted from FaceMaps after each session.</p></li>
                  <li><p><strong>Flexible</strong>: FaceTec 3D FaceMaps can be stored as files, in databases, in blocks, on a server or on a device. Customer-specific encryption schemes can be applied in addition to FaceTec SDK built-in security mechanisms.</p></li>
                </ul>
              </section>

              <hr />

              <section>
                <div className="title">
                  <h2 id="2d-single-image-guidelines">2D Single Image Guidelines</h2>
                </div>
                <p>Learn about 2D Single Image requirements and recommendations.</p>
                <hr/>
              </section>
              <section>
                <h3 id="introduction-and-restrictions">Introduction to 2D & Restrictions</h3>
                <p>A Single 2D Face Image can be used with FaceTec, but to do so, you must generate a Single Image 2D FaceMap. You can do this with the createFacemapFromImage API.  Matching 2D to 2D is not allowed by default in the FaceTec Server SDK since most development teams have poor datasets and/or will most likely draw incorrect conclusions from results.</p>
                <hr />
              </section>

              <section>
                <h3 id="limitations-of-2d">Limitations of 2D</h3>
                <p>Single Image 2D FaceMaps are created from a single 2D image.  Thus, there is <strong>no Liveness data available and no Liveness decision will be returned</strong>. Matching will also be less accurate than performing 3D to 3D Matching.</p>
                <hr />
              </section>

              <section>
                <h3 id="requirements-and-recommendations">2D Image Requirements & Recommendations</h3>
                <p>Your existing 2D Face Images can be used with FaceTec, however the following set of requirements and recommendations for using 2D images must be adhered to. Your matching accuracy will vary depending on how far your image database deviates from the following requirements and recommendations:</p>

                <ul>
                  <li>JPG or PNG. No other image formats are accepted.</li>
                  <li>Face has a frontal pose, mugshot style. Variations in pitch, roll, and yaw will lead to poor accuracy.</li>
                  <li>Face should be generally centered in the image. This is not a requirement, but helpful for performance.</li>
                  <li>Face width should be at least 150 pixels wide. Smaller faces are sometimes accepted but will degrade accuracy.</li>
                  <li>Images containing glare, watermarking, or holograms can negatively affect accuracy. The FaceTec Server SDK V8 contains vastly improved accuracy for photos from government issued Photo IDs, when comparing them to FaceTec 3D FaceMaps.</li>
                  <li>Face images should upright. FaceTec SDKs will detect 90, 180, and 270 degree rotated faces in images, but processing will be faster if the photo is upright.</li>
                </ul>

                <hr />
              </section>

              <section>
                <h3 id="additional-recommendations">2D Image Additional Recommendations</h3>
                <p>In general, conformance to ISO 19794-5 Frontal Face specifications will yield better performance. These include the following guidelines:</p>

                <ul>
                  <li>Neutral expression.</li>
                  <li>Good, even, ambient lighting.</li>
                  <li>Evenly lit face, minimizing any shadows and potential glare or reflections in glasses.</li>
                  <li>High resolution image. A good baseline is around 640x360 portrait.</li>
                </ul>
              </section>

              <section>
                <h3 id="2d-quality">2D Image Low Quality Indicators</h3>
                <p><strong>Rejection: </strong>The FaceTec Server SDK will reject images that are too low quality.  The logic to determine quality is based on internal, proprietary logic.  The reason FaceTec rejects images that are too low quality is because FaceTec is relied upon as a security product, and thus not all images with a face in it can be accepted.  When good quality images are used, you will get good quality results.</p>
                <p><strong>Low Quality Flag: </strong>For images that are borderline quality, the FaceTec Server SDK will allow processing but will flag the 2D FaceMap generated from this image with a "Low Quality Flag".  This flag can be used to indicate to the developer that FaceTec has assessed that Matching performance may be degraded on this FaceMap due to the quality of the underlying image.</p>
              </section>

              <SDKSidebar menuType="main" title="Matching Guide" />

            </div>
          </div>
        </div>
      </div>
    );
  }

});



// WEBPACK FOOTER //
// ./src/js/components/screens/matching-guide.jsx